export const primaryColor = '#000fff';
export const infoColor = '#000FFF'
export const whiteColor = '#FFFFFF';
export const grayColor = '#808080';
export const defaultBorderRadius = '.3rem';
